import { render } from "./CabinetsSkeleton.vue?vue&type=template&id=1a60634e&ts=true"
import script from "./CabinetsSkeleton.vue?vue&type=script&lang=ts"
export * from "./CabinetsSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__